import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, grey } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const defaultColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--data-informative-neutral'],
          highContrast: unityLightTokens['--data-informative-neutral-high-contrast'],
          lowContrast: unityLightTokens['--data-informative-neutral-low-contrast'],
        }
      : {
          main: unityDarkTokens['--data-informative-neutral'],
          highContrast: unityDarkTokens['--data-informative-neutral-high-contrast'],
          lowContrast: unityDarkTokens['--data-informative-neutral-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: grey[400],
        highContrast: grey[700],
        lowContrast: grey[150],
      }
    : {
        main: grey[400],
        highContrast: grey[150],
        lowContrast: grey[800],
      };
};
